/**
 * Battalion command appointments. Each is a singleton — exactly one officer
 * holds 2IC at a time, same for Adjt, same for QM. Orthogonal to `role`: an
 * OFFICER with appointment "2IC" is still role=OFFICER. The DB enforces
 * singleton-ness via a partial unique index on `users.appointment` where the
 * value IS NOT NULL.
 *
 * Phase 7A locks the list to these three. Extending later (Coy Cdr, Trg Off,
 * etc.) requires only adding entries here — storage is VarChar(8), not a
 * Postgres enum.
 */
export const BATTALION_APPOINTMENTS = ['2IC', 'ADJT', 'QM'] as const;
export type BattalionAppointment = (typeof BATTALION_APPOINTMENTS)[number];

/**
 * Human display label per appointment. Kept here (not in display-name.ts) so
 * the constant set lives in one file and the chip primitive can import the
 * label without pulling the broader display helpers.
 */
export const APPOINTMENT_LABEL: Record<BattalionAppointment, string> = {
  '2IC': '2IC',
  ADJT: 'Adjt',
  QM: 'QM',
};

/** Type guard — for narrowing arbitrary strings down to a known appointment. */
export function isBattalionAppointment(value: unknown): value is BattalionAppointment {
  return typeof value === 'string' && (BATTALION_APPOINTMENTS as readonly string[]).includes(value);
}
